import { articles, Article } from "@/data/articles";
import type { Post } from "@/data/articles";

// Use articles internally but keep Post type for compatibility
const forumPosts = articles;

// SEO-optimized short slugs mapped to post IDs
// Format: 3-6 words, keyword + intent, no stop words (pt-BR)
export const seoSlugs: Record<number, string> = {
  1: "pequenos-carocos-no-penis-experiencia",
  2: "carocos-sem-dor-sem-coceira",
  3: "ppp-vs-verrugas-genitais",
  4: "carocos-ist-ou-normal",
  5: "guia-carocos-no-penis",
  6: "carocos-nao-desaparecem",
  7: "carocos-puberdade-normal",
  8: "glandulas-de-tyson-explicadas",
  9: "glandulas-de-tyson-vs-ppp",
  10: "glandulas-de-tyson-nao-sao-ist",
  11: "glandulas-de-tyson-sao-permanentes",
  12: "medico-disse-que-e-normal",
  13: "remocao-glandulas-de-tyson",
  14: "ppp-explicada",
  15: "ppp-vs-hpv",
  16: "ppp-impacto-psicologico",
  17: "preciso-tratar-ppp",
  18: "ppp-dicas-intimidade",
  19: "decisao-remocao-ppp",
  20: "opcoes-remocao-ppp"
};

// Legacy English slugs → new pt-BR slugs (used to serve 301-style redirects)
export const legacyArticleSlugs: Record<string, string> = {
  "small-bumps-penis-experience": "pequenos-carocos-no-penis-experiencia",
  "bumps-no-pain-no-itch": "carocos-sem-dor-sem-coceira",
  "ppp-vs-genital-warts": "ppp-vs-verrugas-genitais",
  "bumps-std-or-normal": "carocos-ist-ou-normal",
  "penile-bumps-guide": "guia-carocos-no-penis",
  "bumps-wont-go-away": "carocos-nao-desaparecem",
  "puberty-bumps-normal": "carocos-puberdade-normal",
  "tyson-glands-explained": "glandulas-de-tyson-explicadas",
  "tyson-glands-vs-ppp": "glandulas-de-tyson-vs-ppp",
  "tyson-glands-not-std": "glandulas-de-tyson-nao-sao-ist",
  "tyson-glands-permanent": "glandulas-de-tyson-sao-permanentes",
  "doctor-said-normal": "medico-disse-que-e-normal",
  "tyson-glands-removal": "remocao-glandulas-de-tyson",
  "ppp-explained": "ppp-explicada",
  "ppp-mental-impact": "ppp-impacto-psicologico",
  "do-i-need-ppp-treatment": "preciso-tratar-ppp",
  "ppp-intimacy-tips": "ppp-dicas-intimidade",
  "ppp-removal-decision": "decisao-remocao-ppp",
  "ppp-removal-options": "opcoes-remocao-ppp"
};

// Generate fallback slug from title (for posts without SEO slug)
export const generateSlugFromTitle = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .substring(0, 60);
};

// Get the SEO slug for a post (prefers short SEO slug, falls back to title-based)
export const getPostSlug = (post: Post): string => {
  return seoSlugs[post.id] || generateSlugFromTitle(post.title);
};

// Find a post by slug (checks both SEO slugs and legacy title-based slugs)
export const findPostBySlug = (slug: string): Post | undefined => {
  // Resolve legacy English slug to current pt-BR slug if applicable
  const resolvedSlug = legacyArticleSlugs[slug] ?? slug;

  // First, check if it matches any SEO slug
  const postIdFromSeo = Object.entries(seoSlugs).find(([_, seoSlug]) => seoSlug === resolvedSlug);
  if (postIdFromSeo) {
    return forumPosts.find(p => p.id === parseInt(postIdFromSeo[0]));
  }
  
  // Fall back to legacy title-based slug matching
  return forumPosts.find(p => generateSlugFromTitle(p.title) === slug);
};

// Check if we should redirect to the SEO slug
export const shouldRedirectToSeoSlug = (currentSlug: string, post: Post): string | null => {
  const seoSlug = seoSlugs[post.id];
  if (seoSlug && currentSlug !== seoSlug) {
    return seoSlug; // Return the SEO slug to redirect to
  }
  return null;
};
